<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>
<div class="container">
    <h1 class="title-default">Desenvolvedor</h1>
    <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Desenvolvedor</span>! Aqui tem todos os acessos a logs do sistema</p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
</div>
